import { useContext } from 'react';
import { Context } from './Context';
export function useFocusManager() {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useFocusManager must be used within a FocusManagerProvider');
    }
    return context;
}
